import ButtonNormal from '@/components/form/ButtonNormal';
import React from 'react';
import styled from 'styled-components';

class ErrorBoundary extends React.Component {
    state = { 
        hasError: false,
        errorInfo: null
    }

    static getDerivedStateFromError(error: unknown) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error: unknown, errorInfo: unknown) {
        this.setState({
            errorInfo: [error, errorInfo]
        })
    }

    reload = () => {
        location.reload();
    }

    render() {
        if (this.state.hasError) {
            return <BackGround>
                <DLG>
                    <InnerContents>
                        <Head>
                            不明なエラーが発生しました。<br />
                            再読み込みしてください。<br />
                            <br />
                            お手数ですが再読み込みしてもエラーが解消しない場合は運営へお問い合わせください。
                        </Head>
                        <ButtonArea>
                            <ButtonNormal onClick={this.reload}>再読み込み</ButtonNormal>
                        </ButtonArea>
                    </InnerContents>
                </DLG>
            </BackGround>
        }

        return this.props.children
    }
}

export default ErrorBoundary


const BackGround = styled.div`
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background-color: #5a5a5a;
`;

const DLG = styled.div`
    position: fixed;
    left: calc(100vw / 2 - 240px);
    top: calc(100vh / 2 - 240px);
    width: 480px;
    height: 480px;
    border-radius: 10px;
    padding: 40px;
    background-color: #ffffff;
`;

const InnerContents = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
`;

const Head = styled.div`
    font-size: large;
    margin: 20px;
`;

const ButtonArea = styled.div`
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-end;
`
